import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import './Modal.css';

const CatchModalContent = (props) => {

  const [fish, setFish] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [boatName, setBoatName] = useState("");
  const [weight, setWeight] = useState(0);
  const [length, setLength] = useState(0);
  const [girth, setGirth] = useState(0);
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const [today, setToday] = useState();
  const [now, setNow] = useState();
  const [points, setPoints] = useState(0);
  const [isTagged, setIsTagged] = useState(false);
  const [isBillfish, setIsBillfish] = useState(false);
  const [isMeatfish, setIsMeatfish] = useState(false);

  const toggleIsTagged = () => {
    setIsTagged(!isTagged);
  }

  const handleAnglerSelection = (e) => {
    let index = e.target.value;
    setFirstName(props.anglerList[index].firstName);
    setLastName(props.anglerList[index].lastName);
    setBoatName(props.anglerList[index].boatName);
  };

  const handleBoatSelection = (e) => {
    setFirstName("n/a");
    setLastName("n/a");
    setBoatName(e.target.value)
  }

  const handleFishSelection = (e) => {
    
    let fish = e.target.value;
    setFish(fish);

    if (fish == "Blue Marlin") {
      setPoints(300);
      setWeight(0);
      setLength(0);
      setGirth(0);
      setIsBillfish(true);
      setIsMeatfish(false);
    } else if (fish == "Sailfish") {
      setPoints(100);
      setWeight(0);
      setLength(0);
      setGirth(0);
      setIsBillfish(true);
      setIsMeatfish(false);
    } else if (fish == "Spearfish") {
      setPoints(150);
      setWeight(0);
      setLength(0);
      setGirth(0);
      setIsBillfish(true);
      setIsMeatfish(false);
    } else if (fish == "White Marlin") {
      setPoints(150);
      setWeight(0);
      setLength(0);
      setGirth(0);
      setIsBillfish(true);
      setIsMeatfish(false);
    } else if (fish == "Tuna" || fish == "Wahoo" || fish == "Dolphin (Dorado, Mahi)") {
      setPoints(0);
      setWeight(0);
      setLength(0);
      setGirth(0);
      setIsTagged(false);
      setIsBillfish(false);
      setIsMeatfish(true);
      setDate(today);
      setTime(now);
    }
  }

  const handleMeatFishScoring = (e) => {
    let weight = e.target.value;
    setWeight(weight);

    let points = weight * 1;
    setPoints(points);
  }

  const delayRefresh = () => {
    setTimeout(() => {
      console.log('Delaying page refresh...');
      window.location.reload(false);
    }, 2500);
  }

  const validateAndSubmitUserInput = () => {

    if (!fish) { 
      toast.error("Please select a species type.");
      return;
    };

    if (!boatName || !firstName) { 
      toast.error("Please select the boat or angler who caught the fish.");
      return;
    };

    // Create catch record
    let catchOptions = {
      method: 'POST',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/catch',
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        fish: fish,
        firstName: firstName,
        lastName: lastName,
        boatName: boatName,
        weight: weight,
        length: length,
        girth: girth,
        date: date,
        time: time,
        points: points,
        isTagged: isTagged,
      })
    }
    const registerCatch = async () =>{
      let response = await axios(catchOptions);
      toast.success("Successfully added a new catch. Please wait while table refreshes.")
    }
    registerCatch();
    delayRefresh();
  }

  useEffect(() => {
    var date = new Date();
    var minute = date.getMinutes();
    var hour = date.getHours();
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    var today = year + '-' + month + '-' + day;
    if (hour < 10) hour = "0" + hour;
    if (minute < 10) minute = "0" + minute;
    var now = hour + ':' + minute;
    console.log("Today: ", today)
    setDate(today);
    setTime(now);
    setToday(today);
    setNow(now);
  }, []);

  return (
    <>
      <div className="modal">
        <div onClick={props.toggleModal} className="overlay"></div>
        <div className="modal-content">

          { props.catchByAngler ? (
            <>
              <h2>Add New Catch to Database by Angler</h2>
              <br/>
              <label>*Angler: </label>
              <select onChange={handleAnglerSelection}>
                <option value="" disabled selected hidden></option>
                {props.anglerList.map((angler, i) => {
                  return <option key={i} value={i} >{angler.firstName + " " + angler.lastName}</option>
                })}
              </select>
              { boatName ? (
                <>
                  <label>Boat: {boatName}</label>
                </>
              ):(
                <></>
              )}
              <br/>
              <br/>
            </>
          ) : (
            <>
              <h2>Add New Catch to Database by Boat</h2>
              <br/>
              <label>*Boat: </label>
              <select onChange={handleBoatSelection}>
                <option value="" disabled selected hidden></option>
                {props.boatList.map((boat, i) => {
                  return <option key={i} value={boat.boatName} >{boat.boatName}</option>
                })}
              </select>
            </>
          )}
          <br/>
          <br/>
          <label>*Species: </label>
          <select onChange={handleFishSelection}>
            <option value="" disabled selected hidden></option>
            {props.fishSpeciesList.map((fish, i) => {
              return <option key={i} value={fish} >{fish}</option>
            })}
          </select>
          <br/>
          <br/>

          { isBillfish ? (
            <>
              <label>Points: {points}</label>
              <br/> 
              <br/> 
              <label>Is tagged?<input type="checkbox" value={isTagged} checked={isTagged} onChange={toggleIsTagged} /></label>
              <br/>
              <br/>
              <label>Date Caught:</label>
              <input 
                type="date" 
                value={date}
                id='date'
                onChange={(e) => setDate(e.target.value)}
                min="2023-07-12"
                max="2023-07-15"
              />
              <label>Time Caught (24h):</label>
              <input 
                type="time" 
                value={time}
                id='time'
                onChange={(e) => setTime(e.target.value)}
              />
            </>
          ):(
            <></>
          )}

          { isMeatfish ? (
            <>
              <label>Points: {points}</label> 
              <br/>
              <br/>
              <label>Weight (1/10th lbs):</label>
              <input 
                type="number" 
                value={weight}
                id='weight'
                onChange={handleMeatFishScoring}
                min="0.1"
                step="0.1"
              />
              <br/>
              <br/>
              <label>Length (1/8th inches):</label>
              <input 
                type="number" 
                value={length}
                id='length'
                onChange={(e) => setLength(e.target.value)}
                min="0.125"
                step="0.125"
              />
              <label>Girth (1/8th inches):</label>
              <input 
                type="number" 
                value={girth}
                id='girth'
                onChange={(e) => setGirth(e.target.value)}
                min="0.125"
                step="0.125"
              /><br/><br></br>
            </>
          ):(
            <></>
          )}

          <br/>
          <br/>
          <button className="btn-modal" onClick={validateAndSubmitUserInput} type="button">Submit</button>
          <button className="close-modal" onClick={props.toggleModal}>CLOSE</button>
        </div>
      </div>  
    </>
  );
}

export default CatchModalContent;

